import React from 'react';
import { FuelButton } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { useFormContext } from 'react-hook-form';
import useAmplitude from '@hooks/useAmplitude';
import { EditAddressType } from '../schema';
import { ActionsPropsInterface } from './ActionsTypes';

function Actions({
  isLoading,
  renderLocation,
  onCancel,
}: ActionsPropsInterface) {
  const { reset } = useFormContext<EditAddressType>();
  const { amplitudeEvent } = useAmplitude();

  function handleClearOrigin() {
    reset();
    amplitudeEvent(`${renderLocation}_edit_address_click_button_cancel`);

    if (onCancel) {
      onCancel();
    }
  }

  return (
    <FuelFlex
      defaultProps={{
        gap: 'km4',
      }}
    >
      <FuelButton
        fullWidth
        type="button"
        variant="tertiary"
        onClick={() => handleClearOrigin()}
        disabled={isLoading}
      >
        Cancelar
      </FuelButton>
      <FuelButton
        fullWidth
        variant="secondary"
        type="submit"
        isLoading={isLoading}
        onClick={() => {
          amplitudeEvent(`${renderLocation}_edit_address_click_button_save`);
        }}
      >
        Salvar
      </FuelButton>
    </FuelFlex>
  );
}

export default Actions;
